import axios from 'axios'
import {Product} from './OrderedProductsModel'
import {API_URL} from '../../../tenant/apiBase'

export const ORDERED_PRODUCTS_URL = `${API_URL}/api/partner-portal/ordered-products`
export const ORDERED_PRODUCT_ACTIONS_URL = `${API_URL}/api/partner-portal/ordered-products/ordered-product-actions` // New endpoint

// Interface for the action payload
export interface ActionPayload {
  product_id: number // Changed from item_id
  quantity: string // Added product quantity from Product model
  product_from: string | null // Added product_from from Product model
  supplier_order_id?: number // Kept as optional
  item_type: string // Kept as required
  reason_id: number // Kept as required
  available_quantity?: number // Kept as optional for partial availability
}

export function getOrderedProducts(token: string | undefined, language: string) {
  return axios.get<{data: Product[]}>(ORDERED_PRODUCTS_URL, {
    headers: {
      token: token || '',
      language: language, // Add language header
    },
  })
}

// Function to post product action
export function postProductAction(payload: ActionPayload, token: string | undefined, language: string) {
  return axios.post(ORDERED_PRODUCT_ACTIONS_URL, payload, {
    headers: {
      token: token || '',
      language: language, // Add language header
    },
  })
}
